/**
 * 认证表格组件
 */

import React from 'react';
import { Card, Table, Button, Space } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, FileOutlined } from '@ant-design/icons';
import type { Certification } from '../types';

interface CertificationTableProps {
    certifications: Certification[];
    onAdd: () => void;
    onEdit: (record: Certification) => void;
    onDelete: (record: Certification) => void;
}

export const CertificationTable: React.FC<CertificationTableProps> = ({
    certifications,
    onAdd,
    onEdit,
    onDelete,
}) => {
    const columns = [
        {
            title: '国家/市场',
            dataIndex: 'country_display',
            key: 'country',
            width: 150,
        },
        {
            title: '认证类型',
            dataIndex: 'certification_type_display',
            key: 'certification_type',
            width: 250,
        },
        {
            title: '证书文件',
            dataIndex: 'certificate_file',
            key: 'certificate_file',
            width: 120,
            render: (file: string) =>
                file ? (
                    <Button
                        type="link"
                        icon={<FileOutlined />}
                        onClick={() => window.open(file, '_blank')}
                        size="small"
                    >
                        查看
                    </Button>
                ) : (
                    '-'
                ),
        },
        {
            title: '操作',
            key: 'actions',
            width: 150,
            fixed: 'right' as const,
            render: (_: any, record: Certification) => (
                <Space>
                    <Button type="link" icon={<EditOutlined />} onClick={() => onEdit(record)} size="small">
                        编辑
                    </Button>
                    <Button type="link" danger icon={<DeleteOutlined />} onClick={() => onDelete(record)} size="small">
                        删除
                    </Button>
                </Space>
            ),
        },
    ];

    return (
        <Card
            title="产品认证"
            extra={
                <Button type="primary" icon={<PlusOutlined />} onClick={onAdd}>
                    添加认证
                </Button>
            }
        >
            <Table
                columns={columns}
                dataSource={certifications}
                rowKey="id"
                scroll={{ x: 1200 }}
                pagination={{ pageSize: 10 }}
            />
        </Card>
    );
};
